export const TTL_USER_INFORMATION = 300000; // 5 minutes

export const STORAGE_KEY = {
	IMAIOS_USER_INFORMATION: 'imaios-user-information',
	SIQ_INFORMATION: 'siq-information'
};

export const PRODUCT = {
	E_ANATOMY: 'prd_eanat',
	VET_ANATOMY: 'prd_vet'
};

export const THIRD_PARTY_PROVIDER_PRODUCT = {
	EAN: PRODUCT.E_ANATOMY,
	VAN: PRODUCT.VET_ANATOMY
};

export const COOKIE = {
	THIRD_PARTY_PROVIDER: 'third-party-provider'
};
